import { styled } from '@mui/material';
import { AppGridContainer, AppSection } from 'src/components';

//
//

const StyledPlansContainer = styled(AppGridContainer)(({ theme }) => ({
  textAlign: 'center',
  alignItems: 'center',
  '& .currencySelector': {
    '& > div': {
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.up('sm')]: {
        justifyContent: 'flex-end',
      },
    }
  }
}));

const StyledPlanItem = styled(AppSection)(({ theme }) => ({
  height: '100%',
  padding: 0,

  '&.planHighlight': {
    border: `2px solid ${theme.palette.primary.main}`
  },
  '& .MuiChip-root': {
    zIndex: 1,
    height: 26,
    fontSize: 10,
    textTransform: 'uppercase',
    color: theme?.palette?.primary?.main,
  },
  '& .mostPopular': {
    backgroundColor: '#fff',
    margin: theme.spacing(1),
    position: 'absolute',
  },
  '& .priceLabel': {
    backgroundColor: theme?.palette?.primary?.lighter,
    margin: '0 auto',
    display: 'flex',
    width: 'fit-content',
    marginTop: '-16px',
    position: 'relative',
  },
}));

export {
  StyledPlansContainer,
  StyledPlanItem
};
